import React, {useState} from 'react'
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations';
import DoubleButton from 'components/popup/components/DoubleButton';
import SimpleSelect from "components/SimpleSelect";
import BooleanItems from "constants/BooleanItems";
import Typography from "components/Typography";
import BoldTypography from "../../../../../../../../../components/BoldTypography";

export const createConfirmAuctionCfg = (auction, sendEmail, onConfirm, message, confirmButtonLabel) => ({
    auction, sendEmail, onConfirm, message, confirmButtonLabel
})

function ConfirmAuction(
    {
        cfg,
        onCancel
    }) {

    const [sendEmail, setSendEmail] = useState(cfg.sendEmail);

    const onConfirm = () => {
        const data= {
            auctionId: cfg.auction.auctionId,
        }
        if(sendEmail !== undefined)
            data.sendEmail = sendEmail;

        cfg.onConfirm(data)
    }

    return (
        <Dialog
            title={Tr('attention')}
            open
            titleCentered
            maxWidth='xs'
            onClose={onCancel}

            dialogActions={<DoubleButton
                justify='flex-end'
                labelFirst={Tr('cancel')}
                labelSecond={Tr(cfg.confirmButtonLabel)}
                onClickFirst={onCancel}
                onClickSecond={onConfirm}
            />}
        >
            <BoldTypography>{Tr(cfg.message)}</BoldTypography>
            {
                sendEmail !== undefined && <>
                <br/>
                <Typography>{Tr('auction_send_email_label')}</Typography>
                <SimpleSelect
                    onChange={(event) => setSendEmail(event.target.value)}
                    items={BooleanItems}
                    value={sendEmail}
                />
                </>
            }


        </Dialog>
    )
}

ConfirmAuction.propTypes = {
    onCancel: PropTypes.func.isRequired,
    cfg: PropTypes.shape({
        auction: PropTypes.object.isRequired,
        sendEmail: PropTypes.bool,
        onConfirm: PropTypes.func.isRequired,
        message: PropTypes.string.isRequired,
        confirmButtonLabel: PropTypes.string.isRequired,
    })
}

export default ConfirmAuction;